// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview Component destroy event class.
 * @author artem.lit@sisense.com (Artem Lytvynov).
 * @copyright Sisense Inc.
 * @licence Sisense License.
 */

'use strict';

const Event = require('@sbi/core.events').Event;

/**
 * This event used to notify application about running component's dispose flow.
 * @extends {Event}
 */
class ComponentDestroy extends Event {
    /**
     * Class constructor.
     * @param {Component} target
     * @constructor
     */
    constructor(target) {
        // noinspection JSCheckFunctionSignatures
        super('componentdestroy', target);
    }
}

// Exports:
exports.ComponentDestroy = ComponentDestroy;
